import { render } from "./AddToCartDetails.vue?vue&type=template&id=73710937"
import script from "./AddToCartDetails.vue?vue&type=script&lang=js"
export * from "./AddToCartDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__